import { render, staticRenderFns } from "./DefaultOne.vue?vue&type=template&id=1fdc5982&scoped=true&"
import script from "./DefaultOne.vue?vue&type=script&lang=js&"
export * from "./DefaultOne.vue?vue&type=script&lang=js&"
import style0 from "./DefaultOne.vue?vue&type=style&index=0&id=1fdc5982&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdc5982",
  null
  
)

export default component.exports